import { render, staticRenderFns } from "./SimulatorAccess.vue?vue&type=template&id=fba916a4&scoped=true&"
import script from "./SimulatorAccess.vue?vue&type=script&lang=js&"
export * from "./SimulatorAccess.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorAccess.vue?vue&type=style&index=0&id=fba916a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba916a4",
  null
  
)

export default component.exports